import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'shortNum'})
export class ShortNumPipe implements PipeTransform {
  transform(number: number, decimals: number, roundDown: boolean, max: number): any {
    if (!number) return number;

    if (max && number >= max) number = max;

    const abs = Math.abs(number);
    let returnString = abs.toString();

    switch (true) {
    case abs >= Math.pow(10, 12): // trillion
        if (roundDown) {
          returnString = `+${Math.floor(number / Math.pow(10, 12))}t`;
        } else {
          returnString = (number / Math.pow(10, 12)).toFixed(decimals) + 't';
        }
        break;
    case abs < Math.pow(10, 12) && abs >= Math.pow(10, 9): // billion
        if (roundDown) {
          returnString = `+${Math.floor(number / Math.pow(10, 9))}b`;
        } else {
          returnString = (number / Math.pow(10, 9)).toFixed(decimals) + 'b';
        }
        break;
    case abs < Math.pow(10, 9) && abs >= Math.pow(10, 6): // million
        if (roundDown) {
          returnString = `+${Math.floor(number / Math.pow(10, 6))}m`;
        } else {
          returnString = (number / Math.pow(10, 6)).toFixed(decimals) + 'm';
        }
        break;
    case abs < Math.pow(10, 6) && abs >= Math.pow(10, 3): // thousand
        if (roundDown) {
          returnString = `+${Math.floor(number / Math.pow(10, 3))}k`;
        } else {
          returnString = (number / Math.pow(10, 3)).toFixed(decimals) + 'k';
        }
        break;
    }

    return returnString;
  }
}



// WEBPACK FOOTER //
// ./src/app/filters/short-number.pipe.ts